<template>
  <div class="bg-[#f7fbfe]">
    <TsContentPage />
    <TsCategoryHomeMenu />
  </div>
</template>

<script setup lang="ts">
const TsContentPage = defineAsyncComponent(
    () => import('~/components/builder/TsContentPage.vue')
);

const TsCategoryHomeMenu = defineAsyncComponent(
    () => import('~/components/organisms/TsCategoryHomeMenu.vue')
);

const rootStore = useRootStore();
const siteBaseUrl = rootStore.siteBaseURL;
const route = useRoute();

schemaHomePage(route, siteBaseUrl)
</script>